import axios from "axios";
import { AI_BASE_URL } from "../config/index";
import { apiRequest } from "../common/api";

export const getAuthorization = async (user, token, collectionIds = []) => {
  const requestUrl = `${AI_BASE_URL}/auth/check_silos?user_id=${user?.id}`;
  const result = await fetch(requestUrl, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!result.ok) {
    throw new Error(`Failed to fetch authorization`);
  }
  const { hasAccess, silos } = await result.json();

  // Check if user has access
  if (!hasAccess) {
    console.i("User does not have access to any silos");
    return [];
  }

  // Return the silos array directly
  return silos || [];
};
